import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CropIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M6 8a1 1 0 011 1v7.2c0 .445.351.8.778.8H22a1 1 0 010 2h-3v3a1 1 0 01-2 0v-3H7.778C6.24 19 5 17.744 5 16.2V9a1 1 0 011-1zm0-7a1 1 0 011 1v3h9.222C17.76 5 19 6.256 19 7.8V15a1 1 0 01-2 0V7.8a.79.79 0 00-.778-.8H2a1 1 0 110-2h3V2a1 1 0 011-1z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
CropIcon.isCarinaIcon = true;
export default CropIcon;
